var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F6F7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3968 23.2172C28.1442 23.2172 26.9172 23.0216 25.7543 22.6379C25.1867 22.4423 24.5422 22.593 24.1692 22.9735L21.8638 24.7146C19.2184 23.3027 17.5254 21.6108 16.1327 18.9847L17.8268 16.7337C18.2533 16.3072 18.4061 15.683 18.2234 15.0984C17.8364 13.928 17.6398 12.7 17.6398 11.4494C17.6398 10.5655 16.9205 9.84619 16.0365 9.84619H12.2956C11.4117 9.84619 10.6924 10.5655 10.6924 11.4494C10.6924 21.7625 19.0837 30.1539 29.3968 30.1539C30.2808 30.1539 31.0001 29.4346 31.0001 28.5506V24.8205C31.0001 23.9365 30.2808 23.2172 29.3968 23.2172Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall2);
export default __webpack_public_path__ + "static/media/call2.0b61537c22f13a5f0bcf3a59c719e278.svg";
export { ForwardRef as ReactComponent };